import { render } from "./Popup.vue?vue&type=template&id=1ecefeda&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=ts"
export * from "./Popup.vue?vue&type=script&lang=ts"

import "./Popup.vue?vue&type=style&index=0&id=1ecefeda&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ecefeda"

export default script